import React, { useEffect, useState } from "react";
import { PiExportBold } from "react-icons/pi";
import { getbusarrivalreport } from "../../../services/Reportservice";
import { Spinner, Offcanvas } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { convertToAMPM, getBusArrivalStatus } from "../../../utilities";
import { FaMapMarkerAlt } from "react-icons/fa";
import { getbusarrivaldetails } from "../../../services/Reportservice";
import { getliveemployeelist } from "../../../services/TransportService";
import { FaUserGroup } from "react-icons/fa6";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import { useWindowWidth } from "../../../utilities";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai"; // or any other close icon you prefer
import { useRef } from "react";
import Employeereport from "./Employeereport";
import Stopreport from "./Stopreport";
const formatTo12Hour = (timeStr) => {
  const parsedTime = parse(timeStr, "HH:mm", new Date());
  return format(parsedTime, "hh:mm a");
};
const exportToPDF = (data) => {
  const doc = new jsPDF(); // Create the PDF document

  // Get current date & time
  const now = new Date();
  const formattedDate = format(now, "dd MMM yyyy, hh:mm a"); // e.g. 14 May 2025, 03:42 PM

  // Add the timestamp to the PDF
  doc.setFontSize(12);
  doc.text(`Report generated on: ${formattedDate}`, 14, 10); // x=14, y=10 for top-left corner

  const tableColumn = [
    "Bus No.",
    "Driver",
    "Route",
    "Shift",
    "Scheduled Arrival",
    "Actual Arrival",
    "Date",
    "Trip Mode",
    "Status",
  ];

  const tableRows = data.map((row) => [
    row.bus?.number_plate || "N/A",
    row.driver?.name || "N/A",
    row.route?.name || "N/A",
    row.shift?.name || "N/A",
    convertToAMPM(row.stop_schedule_time),
    convertToAMPM(row.actual_time),
    format(new Date(), "dd MMM yyyy"), // use today’s datew
    row.trip_mode?.toUpperCase?.() || "-",
    row.status || "-",
  ]);

  // Generate the table below the date
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 20, // Start below the timestamp
  });

  doc.save("bus-arrival-report.pdf");
};
const StopTimeline = ({ stops }) => (
  <div className="px-4 py-3">
    <div
      style={{
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        paddingBottom: "10px",
      }}
    >
      {stops.map((stop, index) => (
        <div
          key={index}
          className="d-flex flex-column align-items-center mx-2 position-relative"
          style={{
            width: "150px", // Fixed width for each stop to create space
            minWidth: "150px",
            position: "relative",
          }}
        >
          <FaMapMarkerAlt color="steelblue" />
          {index !== stops.length - 1 && (
            <div
              style={{
                width: "30px", // Shorter dash length for spacing
                height: "2px",
                background: "#ccc",
                position: "absolute",
                top: "50%",
                left: "100%", // Position it to the right of the current stop
                transform: "translateX(2px)",
              }}
            />
          )}
          <div className="mt-2 text-center" style={{ fontSize: "12px" }}>
            <strong>{stop.stop_name}</strong>
          </div>
          <div className="small text-center text-dark">
            Scheduled:
            {stop.scheduled_time ? formatTo12Hour(stop?.scheduled_time) : "NA"}
            <br />
            Actual:
            {stop.actual_arrival ? formatTo12Hour(stop?.actual_arrival) : "NA"}
            {/* <br />
            Delay: {stop.delay_duration} */}
            <br />
            <span
              className={`badge text-bg-${
                stop.status.toLowerCase() === "delayed"
                  ? "danger-soft"
                  : stop.status.toLowerCase() === "not reached"
                  ? "info-soft"
                  : "success-soft"
              }`}
            >
              {stop.status.toLowerCase() === "delayed"
                ? stop.status + ":" + stop.delay_duration || "NA"
                : stop.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);
const Busarrivalreport = ({ param }) => {
  const navigate = useNavigate();
  const width = useWindowWidth();
  const [tabtype, setTabtype] = useState("");
  const [data, setData] = useState([]);
  const [driverdata, setDriverdata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const handleopens = () => {
    setOpen(true);
  };
  const handlecloses = () => {
    setDriverdata(null);
    setOpen(false);
  };
  const handlesidebar = () => {
    if (showSidebar) {
      setTabtype("");
    } else {
      setTabtype("stop");
    }
    setShowSidebar(!showSidebar);
  };
  const getreport = () => {
    setLoading(true);
    getbusarrivalreport(param)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const columns = [
    {
      name: "Bus No.",
      selector: (row) => (
        <span className="fw-semibold cursor-pointer">
          {row?.bus?.number_plate || "N/A"}
        </span>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Driver",
      selector: (row) => (
        <span className="fw-semibold cursor-pointer">
          {row.driver?.name || "N/A"}
        </span>
      ),
      wrap: true,
    },
    {
      name: "Route",
      selector: (row) => row?.route?.name || "N/A",
      wrap: true,
    },
    {
      name: "Shift",
      selector: (row) => row?.shift?.name || "N/A",
      wrap: true,
    },
    {
      name: "Arrival",
      selector: (row) => {
        const time = row?.stop_schedule_time
          ? convertToAMPM(row.stop_schedule_time)
          : "-";
        const stop = row?.destination_stop?.name || "N/A";

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              lineHeight: 1.2,
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "14px" }}>{time}</span>
            <span style={{ color: "#666", fontSize: "12px" }}>{stop}</span>
          </div>
        );
      },
      wrap: true,
      sortable: true,
      width: "140px",
    },
    {
      name: "Trip mode",
      selector: (row) => {
        const tripType = row?.trip_mode || "";
        const badgeClass =
          tripType.toLowerCase() === "pickup" ? "bg-info" : "bg-secondary";

        return (
          <span className={`badge ${badgeClass}`}>
            {tripType.toUpperCase()}
          </span>
        );
      },
      width: "115px",
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => {
        const { className, text } = getBusArrivalStatus(row?.status);
        return <span className={className}>{text}</span>;
      },
      width: "110px",
      sortable: true,
    },
  ];
  useEffect(() => {
    getreport();
  }, [param]);

  const tabs = {
    stop: <Stopreport rowData={selectedRow} />,
    employee: <Employeereport rowData={selectedRow} />,
  };
  return (
    <>
      <div className="card">
        <div className="d-flex justify-content-end px-3 py-2">
          <button
            className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
            onClick={() => exportToPDF(data)}
            // style={{ height: "38px" }}
            disabled={data.length === 0}
          >
            {" "}
            <PiExportBold size={18} />
            Export
          </button>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : data.length === 0 ? (
            <div className="p-2 text-center">There are no records found.</div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle fs-6 mb-0">
                <thead className="custom-thead table-light">
                  <tr>
                    <th>Bus No.</th>
                    <th>Driver</th>
                    <th>Route</th>
                    <th>Shift</th>
                    <th>Schedule</th>
                    <th>Actual</th>
                    <th>Trip Mode</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => {
                    const schedule_time = row?.stop_schedule_time
                      ? convertToAMPM(row.stop_schedule_time)
                      : "-";
                    const actual_time = row?.actual_time
                      ? convertToAMPM(row.actual_time)
                      : "-";
                    const stop = row?.destination_stop?.name || "N/A";
                    const tripType = row?.trip_mode || "";
                    const badgeClass =
                      tripType.toLowerCase() === "pickup"
                        ? "bg-info"
                        : "bg-secondary";
                    const { className: statusClass, text: statusText } =
                      getBusArrivalStatus(row?.status);

                    return (
                      <tr
                        key={index}
                        onClick={() => {
                          setSelectedRow(row);
                          handlesidebar();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="fw-semibold text-primary cursor-pointer">
                          {row?.bus?.number_plate || "N/A"}
                        </td>
                        <td className="fw-semibold text-primary cursor-pointer">
                          {row.driver?.name || "N/A"}
                        </td>
                        <td>{row?.route?.name || "N/A"}</td>
                        <td>{row?.shift?.name || "N/A"}</td>
                        <td>
                          <div style={{ lineHeight: 1.2 }}>
                            <div
                              className="fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {stop}
                            </div>
                            <div
                              style={{
                                color: "#666",
                                fontSize: "12px",
                                marginTop: "2px",
                              }}
                            >
                              {schedule_time}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style={{ lineHeight: 1.2 }}>
                            <div
                              className="fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {stop}
                            </div>
                            <div
                              style={{
                                color: "#666",
                                fontSize: "12px",
                                marginTop: "2px",
                              }}
                            >
                              {actual_time}
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${badgeClass} text-white`}>
                            {tripType.toUpperCase()}
                          </span>
                        </td>
                        <td>
                          <span className={statusClass}>{statusText}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <Offcanvas
        show={showSidebar}
        onHide={handlesidebar}
        placement="end"
        style={{
          width:
            tabtype === "employee"
              ? width < 992
                ? "80vw"
                : "400px"
              : width < 992
              ? "80vw"
              : "400px",
        }}
      >
        <Offcanvas.Header className="py-1 ps-2 pe-4" closeButton>
          <div>
            <ul className="nav flex-row custom-sidebar-nav px-2">
              <li
                className="nav-item cursor-pointer"
                onClick={() => setTabtype("stop")}
              >
                <span
                  className={`nav-link ${tabtype == "stop" ? "active" : ""}`}
                >
                  Trip log
                </span>
              </li>
              <li
                className="nav-item cursor-pointer"
                onClick={() => setTabtype("employee")}
              >
                <span
                  className={`nav-link ${
                    tabtype == "employee" ? "active" : ""
                  }`}
                >
                  Boarding log
                </span>
              </li>
            </ul>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-2" key={tabtype}>
          {tabs[tabtype]}
        </Offcanvas.Body>
      </Offcanvas>
      <Dialog open={open} onClose={handlecloses} fullWidth maxWidth="xs">
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Driver Details
          <IconButton
            aria-label="close"
            onClick={handlecloses}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <AiOutlineClose size={20} />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <p>
              <span
                className="text-primary d-inline-block"
                style={{ width: "35%", fontWeight: "500" }}
              >
                Full Name:
              </span>
              <span className="text-break">{driverdata?.name}</span>
            </p>
            <p>
              <span
                className="text-primary d-inline-block"
                style={{ width: "35%", fontWeight: "500" }}
              >
                Mobile Number:
              </span>{" "}
              <span className="text-break">{driverdata?.mobile_number}</span>
            </p>
            <p>
              <span
                className="text-primary d-inline-block"
                style={{ width: "35%", fontWeight: "500" }}
              >
                Email:
              </span>
              <span className="text-break">{driverdata?.email}</span>
            </p>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Busarrivalreport;
